var map = {
	"./m1.png": 38272,
	"./m10.png": 41634,
	"./m2.png": 76955,
	"./m3.png": 27954,
	"./m4.png": 9517,
	"./m5.png": 83364,
	"./m6.png": 96927,
	"./m7.png": 18838,
	"./m8.png": 30321,
	"./m9.png": 90376
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68200;